<template>
  <div class="opc-payment-addr__view" v-if="visible">
    <p>{{ defaultAddress.address1 }}</p>
    <p>{{ defaultAddress.address2 }}</p>
    <p>
      {{ defaultAddress.city ? `${defaultAddress.city}, ` : '' }} {{ defaultAddress.state }} {{ defaultAddress.zip }}
    </p>
    <p>{{ defaultAddress.countryName }}</p>
  </div>
</template>

<script>
import { some } from 'lodash'

export default {
  name: 'bill-address-detail',
  props: {
    defaultAddress: Object
  },
  computed: {
    visible() {
      return some(['address1', 'address2', 'city', 'state', 'zip', 'country'], (key) => {
        return !!this.defaultAddress[key]
      })
    }
  }
}
</script>

<style lang="scss">
.opc-payment-addr {
  &__view {
    padding-top: 16px;
    p {
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: rgba(4, 4, 19, 0.56);
    }
  }
}
</style>
